import React from 'react'

const Icon = () => {
  return (
    <svg
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ transform: 'scale(0.9)' }}
    >
      <path
        d='M16.5752 4.25003C16.579 4.63456 16.4265 5.00428 16.1524 5.274L7.10106 14.3256C7.05417 14.372 6.99733 14.4072 6.93506 14.4284L0.559882 16.5535C0.516551 16.5677 0.471154 16.5751 0.425386 16.5752C0.288826 16.5752 0.160338 16.5096 0.0804277 16.3987C0.00051714 16.2879 -0.0214284 16.1453 0.0217131 16.0157L2.1468 9.64066C2.16819 9.57819 2.20345 9.52136 2.24978 9.47465L11.2982 0.426365C11.5712 0.154566 11.9403 0.00131707 12.3255 6.14073e-06C12.7111 -0.00111934 13.081 0.152506 13.3527 0.426365L16.1527 3.22633C16.423 3.4985 16.5747 3.86646 16.5752 4.25003ZM3.15114 9.77514L4.6754 11.299L11.7248 4.24975L10.2005 2.7259L3.15114 9.77514ZM3.46346 14.6894L1.88628 13.1123L1.09731 15.4784L3.46346 14.6894ZM6.01358 13.8394L2.73619 10.5622L2.18693 12.2104L4.36489 14.3887L6.01358 13.8394ZM13.8495 6.37523L12.3253 4.85138L5.27589 11.9001L6.80015 13.424L13.8495 6.37523ZM15.7255 4.25018C15.7238 4.09224 15.6615 3.94068 15.5516 3.82701L12.7516 1.02762C12.5135 0.798783 12.1373 0.798783 11.8992 1.02762L10.8013 2.12511L14.4503 5.77438L15.5518 4.67292C15.666 4.56225 15.7289 4.40924 15.7255 4.25018Z'
        fill='#242424'
      />
      <line x1='3.89844' y1='16.5' x2='10.5484' y2='16.5' stroke='black' strokeLinecap='round' />
    </svg>
  )
}

export default Icon
